import { appTypes, getAppType } from "./app";

const appType = getAppType();

if (!appTypes[appType]) {
  throw new Error(`The app type ${appType} is not supported`);
}
